import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Dec 31 2019
 * @author Vojtěch Smolař
 */
import { DomainObject } from '@logio/common-be-fe';
export var DPTaskTreeNode =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DPTaskTreeNode, _DomainObject);

  function DPTaskTreeNode(path, name, id, type, attempts, timeout, prerequisites, cfg) {
    var _this;

    _classCallCheck(this, DPTaskTreeNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DPTaskTreeNode).call(this));
    _this.path = path;
    _this.name = name;
    _this.id = id;
    _this.type = type;
    _this.attempts = attempts;
    _this.timeout = timeout;
    _this.prerequisites = prerequisites;
    _this.cfg = cfg;
    return _this;
  }

  return DPTaskTreeNode;
}(DomainObject);